<div
  (click)="onBackdropClick($event)"
  class="fixed inset-0 z-40 bg-gray-950/50 transition-opacity duration-300 ease-out"
  [ngClass]="open ? 'opacity-100 visible pointer-events-auto' : 'opacity-0 invisible pointer-events-none'"
>
  <!-- Contenedor centrado con animación desde abajo -->
  <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div
      class="bg-white rounded-2xl shadow-lg p-6 transition-all duration-700 ease-in-out will-change-transform w-full max-w-xl"
      [ngClass]="open ? 'translate-y-0 scale-100 opacity-100' : 'translate-y-full scale-95 opacity-0'"
    >
      <div
        class="px-2 sm:px-4 py-3 border-b border-amber-300 flex justify-between items-center bg-amber-400 rounded-t-2xl"
      >
        <h3 class="text-base sm:text-lg font-medium text-black">
          Verificar correo electrónico
        </h3>
        <button
          (click)="close()"
          class="text-black hover:text-gray-800 focus:outline-none transition-transform duration-200 hover:scale-105"
          aria-label="Cerrar"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="mt-4 text-sm text-gray-700">
        <p>
          Te hemos enviado un correo para verificar tu cuenta. Si no lo
          recibiste, puedes reenviar la verificación.
        </p>

        <div class="mt-4 flex gap-3">
          <button
            [disabled]="isLoading()"
            (click)="onSendEmail()"

            class="px-4 py-2 bg-amber-500 text-white rounded-md hover:bg-amber-600 transition-colors"
          >
            {{ isLoading() ? 'Enviando...' : 'Reenviar correo' }}
          </button>
          <button

            (click)="close()"
            class="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
